import React, { useState } from "react";
import PropTypes from "prop-types";
import { Header, Button, Grid, Input } from "semantic-ui-react";

import { StyledGridRow, StyledSelect } from "../common/StyledComponents";
import Spinner from "../common/Spinner";
import { BranchOptions, RoleOptions, StatusOptions } from "../common/constants";
import { convertArraytoSelectOptionsList } from "../common/helpers";

const SearchUsers = (props) => {
  const { users } = props;

  const [userName, setUserName] = useState(null);
  const [branchName, setBranchName] = useState(null);
  const [roleType, setRoleType] = useState(null);
  const [statusType, setStatusType] = useState(null);

  if (!users.length) return <Spinner />;
  let _branchOptions = ["", ...BranchOptions];
  let _roleOptions = ["", ...RoleOptions];
  let _activeList = ["", ...StatusOptions];

  _branchOptions = convertArraytoSelectOptionsList(
    [...new Set(_branchOptions)],
    "branch"
  );
  _roleOptions = convertArraytoSelectOptionsList(
    [...new Set(_roleOptions)],
    "role"
  );
  _activeList = convertArraytoSelectOptionsList(
    [...new Set(_activeList)],
    "status"
  );

  const onSearch = () => {
    let user = {};
    let branch = {};
    let role = {};
    let status = {};
    if (userName) {
      user = {
        firstName: userName,
      };
    }
    if (branchName && branchName !== "All") {
      branch = {
        branchName,
      };
    }
    if (roleType && roleType !== "All") {
      role = {
        roleType,
      };
    }
    if (statusType && statusType !== "All") {
      status = {
        statusType,
      };
    }
    const obj = {
      ...user,
      ...branch,
      ...role,
      ...status,
    };
    props.onSearchClick(obj);
  };

  return (
    <>
      <StyledGridRow className="nooverflow">
        <Grid.Row columns={2} className="padd">
          <Grid.Column>
            <Header as="h1">Admin Settings</Header>
          </Grid.Column>
          <Grid.Column textAlign="right" verticalAlign="middle">
            <Button primary onClick={(e) => props.openAddUserModal(e, null)}>
              Add New User
            </Button>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="bg-lightGrey padd searchControls">
          <Grid.Column width={4}>
            <label htmlFor="searchName">Search:</label>
            <Input
              id="searchName"
              name="searchName"
              placeholder="Enter a search term"
              style={{ width: "100%" }}
              onChange={(e, { name, value }) => setUserName(value)}
            ></Input>
          </Grid.Column>
          <Grid.Column width={5}>
            <label htmlFor="branch">Branch:</label>
            <StyledSelect
              fluid
              icon="angle down"
              id="branch"
              name="branch"
              placeholder="Branch"
              options={_branchOptions}
              onChange={(e, { name, value }) => setBranchName(value)}
            ></StyledSelect>
          </Grid.Column>
          <Grid.Column width={3}>
            <label htmlFor="type">Type:</label>
            <StyledSelect
              fluid
              icon="angle down"
              id="role"
              name="role"
              placeholder="Type"
              options={_roleOptions}
              onChange={(e, { name, value }) => setRoleType(value)}
            ></StyledSelect>
          </Grid.Column>
          <Grid.Column width={2}>
            <label htmlFor="status">Status:</label>
            <StyledSelect
              fluid
              icon="angle down"
              id="status"
              name="status"
              placeholder="Status"
              options={_activeList}
              onChange={(e, { name, value }) => setStatusType(value)}
            ></StyledSelect>
          </Grid.Column>
          <Grid.Column width={2} floated="right" verticalAlign="bottom">
            <Button primary fluid onClick={() => onSearch()}>
              Search
            </Button>
          </Grid.Column>
        </Grid.Row>
      </StyledGridRow>
    </>
  );
};

SearchUsers.propTypes = {};

SearchUsers.defaultProps = {};

export default SearchUsers;
